import { useTranslation } from 'react-i18next';

import Modal from 'components/antdCustom/Modal';

const ModalConfirmOpenStore = (props) => {
  const { visible, onCancel, value: isOpen, onChange } = props;
  const { t } = useTranslation();
  const onOk = () => {
    onChange(!isOpen);
    onCancel();
  };

  return (
    <Modal
      title={
        isOpen ? t('closeStore.confirmTitle') : t('openStore.confirmTitle')
      }
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}>
      {isOpen ? (
        <div>{t('closeStore.confirmMessage')}</div>
      ) : (
        <div>{t('openStore.confirmMessage')}</div>
      )}
    </Modal>
  );
};

export default ModalConfirmOpenStore;
